import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import {
  commonEN,
  landingEN,
  numberRequestEN,
  numberManagementEN,
  ordersEN,
  numberAllocationEN,
  endCustomerEN,
  endCustomerDetailsEN,
  approvalsEN,
  endCustomerServicesEN,
  endCustomerAddEN,
  bundleEN,
  regulatoryBundleViewEN,
  bundlesManagementEN,
  regulatoryBundleEN,
  deleteBundleEN,
  submitBundleEN,
} from "src/localization/en";

export const resources = {
  en: {
    common: commonEN,
    landing: landingEN,
    number_mgmt: numberManagementEN,
    number_req: numberRequestEN,
    number_allocation: numberAllocationEN,
    orders: ordersEN,
    end_customer: endCustomerEN,
    end_customer_details: endCustomerDetailsEN,
    approvals: approvalsEN,
    end_customer_services: endCustomerServicesEN,
    end_customer_add: endCustomerAddEN,
    bundle: bundleEN,
    regulatory_view: regulatoryBundleViewEN,
    bundle_management: bundlesManagementEN,
    submit_bundle: submitBundleEN,
    regulatory_bundle: regulatoryBundleEN,
    delete_bundle: deleteBundleEN,
  },
};

// eslint-disable-next-line import/no-named-as-default-member
i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    defaultNS: "common",
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });

export default i18next;
